import { createAction, props } from '@ngrx/store';

import { PmsCredentialModel } from '@shared/interfaces/pms-credential-model.interface';

/**
 * get System Config
 */
export const getServiceConfig = createAction('[System Config] get System Config');
export const getServiceConfigSuccess = createAction(
  '[System Config] get System Config success',
  props<{ serviceConfig: PmsCredentialModel[] }>()
);
export const getServiceConfigError = createAction('[System Config] get System Config error');

export const setServiceSectionExpanded = createAction(
  '[System Config] setSystemSectionExpanded',
  props<{ section: 'Statuses' | 'Resident' | 'Triggers'; state: boolean }>()
);
